import { RigBase } from './base/rig-base';

export class Rig extends RigBase { }